import React, { useState, useEffect } from 'react'
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import { getBudgetAggregatorByData, getBudgetStatsAggregatorByData } from '../../ActionCreator';
import moment from 'moment'
import { saveBugetPlan } from '../../../actioncreatormarketing';
import CustomCheckbox2 from '../../../BuisnessDashboard/common/CustomCheckbox2';
import Popup from '../../../../../presentationals/Popup/Popup.component';

// ── Shared Modal Styles ─────────────────────────────────────────────────────
const overlayStyle = {
    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
}
const modalStyle = {
    background: '#fff', borderRadius: '12px', width: '800px', maxWidth: '95vw',
    maxHeight: '90vh', display: 'flex', flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)', overflow: 'hidden',
}
const modalHeaderStyle = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '16px 20px', borderBottom: '1px solid #e5e7eb', flexShrink: 0,
}
const modalBodyStyle = { overflowY: 'auto', padding: '20px', flex: 1 }
const modalFooterStyle = {
    display: 'flex', justifyContent: 'flex-end', gap: '10px',
    padding: '12px 20px', borderTop: '1px solid #e5e7eb', flexShrink: 0, background: '#fff',
}
const closeBtnStyle = {
    border: 'none', background: 'transparent', fontSize: '24px',
    color: '#9ca3af', cursor: 'pointer', lineHeight: 1,
}
const cancelBtnStyle = {
    border: '1px solid #d1d5db', background: '#fff', color: '#374151',
    borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: 600, cursor: 'pointer',
}
const saveBtnStyle = {
    border: 'none', background: '#035865', color: '#fff',
    borderRadius: '6px', padding: '8px 18px', fontSize: '13px', fontWeight: 600, cursor: 'pointer',
}
const inputStyle = {
    width: '100%', height: '38px', padding: '8px 12px',
    borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '13px',
    outline: 'none', transition: 'border-color 0.15s ease', boxSizing: 'border-box'
}
const labelStyle = {
    display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151',
    marginBottom: '6px', textTransform: 'none', textAlign: 'left'
}
const fieldGroupStyle = {
    marginBottom: '16px'
}
export default function Budget({ Data, dateFilterPopup, commonFilter, setDateFilterPopup }) {
    console.log("Data", Data)
    const [statsData, setStatsData] = useState({})
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState({})

    // Add Budget states
    const [showAddBudget, setShowAddBudget] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [objectData, setObjectData] = useState({
        aggregator: Data?.id || "",
        startDate: "",
        endDate: "",
        totalBudget: "",
        leadsExpected: "",
        commitedLeads: "",
        commitedDisbursment: "",
        commitedDisbursmentAmount: "",
        expectedDisbursmentAmount: "",
        notify: false,
        email: "",
    })

    useEffect(() => {
        if (Data?.id) {
            setObjectData(prev => ({ ...prev, aggregator: Data.id }))
        }
    }, [Data])

    const handleChange = (e, type) => {
        const { value, checked } = e.target;
        setObjectData((prev) => ({
            ...prev,
            [type]: type === "notify" ? checked : value
        }))
    }

    const removePopup = () => {
        setTimeout(() => {
            setPopup({ show: false, popupStatus: "" })
        }, 3000)
    }

    const handleSaveBudget = () => {
        const obj = {
            aggregatorId: objectData?.aggregator || "",
            sDate: moment(objectData?.startDate).format("DD-MM-YYYY"),
            eDate: moment(objectData?.endDate).format("DD-MM-YYYY"),
            amount: objectData?.totalBudget || "",
            expectedLeadCount: objectData?.leadsExpected || "",
            committedLeads: objectData?.commitedLeads || "",
            commitedDisbursement: objectData?.commitedDisbursment || "",
            committedDisbAmt: objectData?.commitedDisbursmentAmount || "",
            expectedDisbAmt: objectData?.expectedDisbursmentAmount || "",
            notification: objectData?.notify || "",
            emailId: objectData?.email || "",
        }
        setLoader(true)
        saveBugetPlan(obj, callback => {
            setLoader(false)
            if (callback === 'success') {
                setPopup({ show: true, popupStatus: "Data Save Successfully !" })
                removePopup()
                const currentFilterObj = { start: moment(commonFilter.fromDate).format("DD-MM-YYYY"), end: moment(commonFilter.toDate).format("DD-MM-YYYY") }
                statsApi(currentFilterObj)
                graphApi(currentFilterObj)
                setShowAddBudget(false)
                setObjectData({
                    aggregator: Data?.id || "",
                    startDate: "",
                    endDate: "",
                    totalBudget: "",
                    leadsExpected: "",
                    commitedLeads: "",
                    commitedDisbursment: "",
                    commitedDisbursmentAmount: "",
                    expectedDisbursmentAmount: "",
                    notify: false,
                    email: "",
                })
            } else {
                setPopup({ show: true, popupStatus: "Please try again later !" })
                removePopup()
            }
        })
    }

    const closePopup = () => setPopup({ show: false, popupStatus: "" })

    useEffect(() => {
        if (
            commonFilter?.fromDate !== dateFilterPopup.from ||
            commonFilter?.toDate !== dateFilterPopup.to
        ) {
            setDateFilterPopup((prev) => ({
                ...prev,
                from: commonFilter.fromDate,
                to: commonFilter.toDate
            }));
        }
        const obj = { start: moment(commonFilter.fromDate).format("DD-MM-YYYY"), end: moment(commonFilter.toDate).format("DD-MM-YYYY") }
        statsApi(obj)
        graphApi(obj)

    }, [commonFilter])

    const statsApi = (obj) => {
        setLoader(true)
        getBudgetAggregatorByData(obj?.start, obj?.end, Data?.id, callback => {
            setLoader(false)
            setStatsData(callback?.data?.[0])
        })
    }
    const graphApi = (obj) => {
        setLoader(true)
        getBudgetStatsAggregatorByData(obj?.start, obj?.end, Data?.id, Data?.name, callback => {
            setLoader(false)
            settableData(callback?.data)
            // settableData({
            //     "data": [
            //         {
            //             "date": "01 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "02 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "03 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "04 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "05 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "06 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "07 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "08 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "09 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "10 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "11 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "12 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "13 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "14 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         },
            //         {
            //             "date": "15 Jan",
            //             "budgetedDisbursement": 5000000.0,
            //             "actualDisbursement": 0.0
            //         }
            //     ],
            //     "stats": {
            //         "budgetedLeads": 600,
            //         "actualLeads": 0,
            //         "costPerLead": 0.0,
            //         "withinBudget": 100.0
            //     }
            // })
        })
    }
    return (
        <>
            {loader ? <Loader /> : ""}
            <div className="OverView-Main-Section min-size-marketing-1800">

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%', marginLeft: '0', marginTop: '0' }}>
                        <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 'auto' }}>
                                <path d="M16 2V6M8 2V6" stroke="#686C70" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="#686C70" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3 10H21" stroke="#686C70" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 18.5002L9.99999 13.8474C9.99999 13.6557 9.86325 13.5002 9.69458 13.5002H9M14 18.4983L15.4855 13.8923C15.4951 13.8626 15.5 13.8315 15.5 13.8002C15.5 13.6346 15.3657 13.5002 15.2 13.5002L13 13.5" stroke="#686C70" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <h6>Budget Period</h6>
                        </div>
                        <h5 style={{ marginTop: '20px', color: '#035865', fontSize: '14px' }}>{Data?.start + " to " + Data?.end}</h5>
                        {/* <h6 style={{ color: '#035865' }}>Monthly</h6> */}
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32.5 26.6668V20.01C32.5 17.5327 32.5 16.2939 32.074 15.1602C31.648 14.0265 30.8323 13.0943 29.201 11.2299L26.6667 8.3335H13.3333L10.799 11.2299C9.16763 13.0943 8.35197 14.0265 7.92598 15.1602C7.5 16.2939 7.5 17.5327 7.5 20.01V26.6668C7.5 31.3808 7.5 33.7378 8.96447 35.2023C10.4289 36.6668 12.7859 36.6668 17.5 36.6668H22.5C27.214 36.6668 29.571 36.6668 31.0355 35.2023C32.5 33.7378 32.5 31.3808 32.5 26.6668Z" stroke="#0E2B94" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.834 26.1387C15.834 28.1877 18.9238 29.8675 21.8882 28.9257C24.8527 27.9837 24.4168 25.2082 23.4112 24.1182C22.4055 23.0283 20.9257 23.211 19.2338 23.1253C15.4319 22.9325 15.1635 19.2872 18.2418 17.845C20.5002 16.7868 23.3972 18.1438 23.7308 20.0002M19.9523 15.8335V17.463M19.9523 29.5342V30.8335" stroke="#0E2B94" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.5 3.3335H27.5C28.2765 3.3335 28.6648 3.3335 28.9712 3.46036C29.3795 3.62951 29.704 3.95398 29.8732 4.36236C30 4.66865 30 5.05693 30 5.8335C30 6.61006 30 6.99835 29.8732 7.30463C29.704 7.71301 29.3795 8.03748 28.9712 8.20663C28.6648 8.3335 28.2765 8.3335 27.5 8.3335H12.5C11.7234 8.3335 11.3352 8.3335 11.0289 8.20663C10.6205 8.03748 10.296 7.71301 10.1269 7.30463C10 6.99835 10 6.61006 10 5.8335C10 5.05693 10 4.66865 10.1269 4.36236C10.296 3.95398 10.6205 3.62951 11.0289 3.46036C11.3352 3.3335 11.7234 3.3335 12.5 3.3335Z" stroke="#0E2B94" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <h5>{statsData?.budgetAllocated ?? ""}</h5>
                        <h6>Budget Allocated</h6>
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.6667 5.8335H23.3333C24.8833 5.8335 25.6583 5.8335 26.2942 6.00386C28.0195 6.4662 29.3673 7.81395 29.8297 9.5394C30 10.1752 30 10.9502 30 12.5002H8.33333C6.49238 12.5002 5 11.0078 5 9.16683C5 7.32588 6.49238 5.8335 8.33333 5.8335H13.3333" stroke="#74529D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5 9.1665V25.8332C5 30.5472 5 32.9042 6.46447 34.3687C7.92893 35.8332 10.2859 35.8332 15 35.8332H25C29.714 35.8332 32.071 35.8332 33.5355 34.3687C35 32.9042 35 30.5472 35 25.8332V22.4998C35 17.7858 35 15.4288 33.5355 13.9643C32.071 12.4998 29.714 12.4998 25 12.4998H11.6667" stroke="#74529D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M35.0007 20.8335H31.6673C30.8923 20.8335 30.5048 20.8335 30.187 20.9187C29.3241 21.1498 28.6503 21.8237 28.4192 22.6865C28.334 23.0043 28.334 23.3918 28.334 24.1668C28.334 24.9418 28.334 25.3293 28.4192 25.6472C28.6503 26.51 29.3241 27.1838 30.187 27.415C30.5048 27.5002 30.8923 27.5002 31.6673 27.5002H35.0007" stroke="#74529D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M17.4993 4.1665C20.721 4.1665 23.3327 6.77817 23.3327 9.99984C23.3327 10.8945 23.1314 11.7421 22.7714 12.4998H12.2274C11.8674 11.7421 11.666 10.8945 11.666 9.99984C11.666 6.77817 14.2777 4.1665 17.4993 4.1665Z" stroke="#74529D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>



                        <h5>{statsData?.budgetConsumed ?? ""}</h5>
                        <h6>Budget Consumed</h6>
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.1673 20.0017C24.1673 22.3028 22.3018 24.1683 20.0006 24.1683C17.6995 24.1683 15.834 22.3028 15.834 20.0017C15.834 17.7005 17.6995 15.835 20.0006 15.835C22.3018 15.835 24.1673 17.7005 24.1673 20.0017Z" stroke="#F49F28" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M26.6673 8.33496C30.7997 8.33496 33.6512 8.97529 35.2222 9.46216C36.1267 9.74248 36.6673 10.5998 36.6673 11.5467V27.8055C36.6673 29.664 34.6205 31.0623 32.7943 30.7175C31.2275 30.4217 29.1852 30.184 26.6673 30.184C18.7492 30.184 16.85 33.1935 5.24198 30.6337C4.12173 30.3867 3.33398 29.3792 3.33398 28.232V11.5369C3.33398 9.91046 4.86863 8.72439 6.46395 9.04096C16.9952 11.1307 19.0355 8.33496 26.6673 8.33496Z" stroke="#F49F28" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.33398 15.0013C6.5862 15.0013 9.5087 12.3431 9.88233 9.59157M30.8348 9.16797C30.8348 12.5674 33.7765 15.783 36.6673 15.783M36.6673 25.0013C33.5022 25.0013 30.4341 27.185 30.1706 30.1652M10.0015 30.8282C10.0015 27.1462 7.0167 24.1615 3.3348 24.1615" stroke="#F49F28" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <h5>{statsData?.budgetRemaining ?? ""}</h5>
                        <h6>Remaining</h6>
                    </div>
                    <div className="custom-tabss-new text-center" style={{ margin: '25px', width: '20%', marginRight: '0' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.3333 15C12.3502 15 7.5 19.8502 7.5 25.8332C7.5 31.8164 12.3502 36.6666 18.3333 36.6666C24.3164 36.6666 29.1666 31.8164 29.1666 25.8332C29.1666 19.8502 24.3164 15 18.3333 15Z" stroke="#4FA564" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M33.3346 14.1663L25.6873 7.15629C24.5741 6.13594 24.0176 5.62576 23.3486 5.64029C22.6795 5.65484 22.1456 6.18871 21.0778 7.25644L19.4685 8.86589C18.528 9.80637 18.0576 10.2766 17.456 10.3309C16.8543 10.3851 16.3076 10.0066 15.214 9.24951L6.66797 3.33301M33.3346 14.1663H27.5013M33.3346 14.1663V9.16634" stroke="#4FA564" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.7305 30.2782V21.3893M18.3346 21.3893V19.167M18.3346 32.5003V30.2782M15.7305 25.8337H20.9387M20.9387 25.8337C21.8017 25.8337 22.5012 26.58 22.5012 27.5003V28.6115C22.5012 29.532 21.8017 30.2782 20.9387 30.2782H14.168M20.9387 25.8337C21.8017 25.8337 22.5012 25.0875 22.5012 24.167V23.056C22.5012 22.1355 21.8017 21.3893 20.9387 21.3893H14.168" stroke="#4FA564" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>


                        <h5>{statsData?.variance ?? ""}</h5>
                        <h6>Variance %</h6>
                    </div>
                </div>

                <div className="row">
                    {/* <div className="col-sm-5 col-xs-12">
                        <div className="customcard-overview">
                            <div className="topHeader">
                                <h5>Credit & Risk KPIs </h5>
                            </div>

                            <div className="funnelBars" style={{ margin: '17px 0' }}>
                                <div className='barss green-bar'>
                                    <h5>Credit Bureau Pull Success Rate</h5>
                                    <h5><b>40</b></h5>
                                </div>
                                <div className='barss dark-yellow-bar'>
                                    <h5>BRE Pass Rate (%) </h5>
                                    <h5><b>40</b></h5>
                                </div>
                                <div className='barss blue-bar'>
                                    <h5>Approval Rate (%)</h5>
                                    <h5><b>40</b></h5>
                                </div>
                                <div className='barss redish-bar'>
                                    <h5>FOIR Pass Rate</h5>
                                    <h5><b>40</b></h5>
                                </div>
                                <div className='barss purpleish-bar'>
                                    <h5>Policy Rejection Reasons (%)</h5>
                                    <h5><b>40</b></h5>
                                </div>
                                <div className='barss yellow-bar'>
                                    <h5>Aggregator-wise Risk Score</h5>
                                    <h5><b>40</b></h5>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-sm-12 col-xs-12">
                        <div className='Areachart-box'>
                            <div className='topHeader'>
                                <div style={{display:'flex',justifyContent:'space-between',width:'100%',marginBottom:'10px'}}>
                                    <h5>Budget vs Actual Trend</h5>
                                    <button
                                        style={{
                                            border: 'none', background: '#035865', color: '#fff',
                                            borderRadius: '6px', padding: '6px 14px', fontSize: '13px',
                                            fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px'
                                        }}
                                        onClick={() => setShowAddBudget(true)}
                                    >
                                        <svg style={{ width: 'auto' }} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                                        </svg>
                                        Add Budget
                                    </button>
                                </div>
                            </div>
                            <div className='custom-area-progress' style={{ background: "#4FA564" }}>
                                <h5>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.9905 19H19H18.9905ZM18.9905 19C18.3678 19.6175 17.2393 19.4637 16.4479 19.4637C15.4765 19.4637 15.0087 19.6537 14.3154 20.347C13.7251 20.9374 12.9337 22 12 22C11.0663 22 10.2749 20.9374 9.68457 20.347C8.99128 19.6537 8.52349 19.4637 7.55206 19.4637C6.76068 19.4637 5.63218 19.6175 5.00949 19C4.38181 18.3776 4.53628 17.2444 4.53628 16.4479C4.53628 15.4414 4.31616 14.9786 3.59938 14.2618C2.53314 13.1956 2.00002 12.6624 2 12C2.00001 11.3375 2.53312 10.8044 3.59935 9.73817C4.2392 9.09832 4.53628 8.46428 4.53628 7.55206C4.53628 6.76065 4.38249 5.63214 5 5.00944C5.62243 4.38178 6.7556 4.53626 7.55208 4.53626C8.46427 4.53626 9.09832 4.2392 9.73815 3.59937C10.8044 2.53312 11.3375 2 12 2C12.6625 2 13.1956 2.53312 14.2618 3.59937C14.9015 4.23907 15.5355 4.53626 16.4479 4.53626C17.2393 4.53626 18.3679 4.38247 18.9906 5C19.6182 5.62243 19.4637 6.75559 19.4637 7.55206C19.4637 8.55858 19.6839 9.02137 20.4006 9.73817C21.4669 10.8044 22 11.3375 22 12C22 12.6624 21.4669 13.1956 20.4006 14.2618C19.6838 14.9786 19.4637 15.4414 19.4637 16.4479C19.4637 17.2444 19.6182 18.3776 18.9905 19Z" fill="white" />
                                        <path d="M18.9905 19H19M18.9905 19C18.3678 19.6175 17.2393 19.4637 16.4479 19.4637C15.4765 19.4637 15.0087 19.6537 14.3154 20.347C13.7251 20.9374 12.9337 22 12 22C11.0663 22 10.2749 20.9374 9.68457 20.347C8.99128 19.6537 8.52349 19.4637 7.55206 19.4637C6.76068 19.4637 5.63218 19.6175 5.00949 19C4.38181 18.3776 4.53628 17.2444 4.53628 16.4479C4.53628 15.4414 4.31616 14.9786 3.59938 14.2618C2.53314 13.1956 2.00002 12.6624 2 12C2.00001 11.3375 2.53312 10.8044 3.59935 9.73817C4.2392 9.09832 4.53628 8.46428 4.53628 7.55206C4.53628 6.76065 4.38249 5.63214 5 5.00944C5.62243 4.38178 6.7556 4.53626 7.55208 4.53626C8.46427 4.53626 9.09832 4.2392 9.73815 3.59937C10.8044 2.53312 11.3375 2 12 2C12.6625 2 13.1956 2.53312 14.2618 3.59937C14.9015 4.23907 15.5355 4.53626 16.4479 4.53626C17.2393 4.53626 18.3679 4.38247 18.9906 5C19.6182 5.62243 19.4637 6.75559 19.4637 7.55206C19.4637 8.55858 19.6839 9.02137 20.4006 9.73817C21.4669 10.8044 22 11.3375 22 12C22 12.6624 21.4669 13.1956 20.4006 14.2618C19.6838 14.9786 19.4637 15.4414 19.4637 16.4479C19.4637 17.2444 19.6182 18.3776 18.9905 19Z" stroke="#4FA564" stroke-width="1.5" />
                                        <path d="M9 12.8929C9 12.8929 10.2 13.5447 10.8 14.5C10.8 14.5 12.6 10.75 15 9.5" stroke="#4FA564" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Within Budget
                                </h5>

                                <div className="progress-bar-new-2" style={{ width: '30%' }}>
                                    <div className="progress-bar-field">
                                        <div className="inside-bar" style={{ width: (tableData?.stats?.withinBudget ?? 0) + "%" }}></div>
                                    </div>
                                    <h6><b>{tableData?.stats?.withinBudget ?? 0}%</b></h6>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-8 col-xs-12">
                                    <div style={{ width: "100%", height: 300 }}>
                                        <ResponsiveContainer width="100%" height="100%">
                                            <LineChart
                                                data={tableData?.data || []}
                                                margin={{
                                                    top: 5,
                                                    right: 20,
                                                    left: 0,
                                                    bottom: 5,
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />

                                                <XAxis dataKey="date" />

                                                <YAxis />

                                                <Tooltip />

                                                {tableData?.data?.length > 0 && <Legend />}

                                                <Line
                                                    type="monotone"
                                                    dataKey="budgetedDisbursement"
                                                    stroke="#74529D"
                                                    strokeWidth={2}
                                                />

                                                <Line
                                                    type="monotone"
                                                    dataKey="actualDisbursement"
                                                    stroke="#FF7070"
                                                    strokeWidth={2}
                                                    activeDot={{ r: 6 }}
                                                />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={{ border: "1px solid #D9D9D9", borderRadius: '10px', marginTop: '15px' }}>
                                        <div style={{ padding: '10px', borderBottom: '1px solid #D9D9D9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#0C0B10" }}>Budgeted Leads</h5>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#686C70" }}>{tableData?.stats?.budgetedLeads ?? 0}</h5>
                                        </div>
                                        <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#0C0B10" }}>Actual Leads</h5>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#686C70" }}>{tableData?.stats?.actualLeads ?? 0}</h5>
                                        </div>
                                        {/* <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#0C0B10" }}><b>+4,200</b></h5>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#327E45" }}><b>₹9.3Cr</b></h5>
                                        </div> */}

                                    </div>
                                    <div style={{ border: "1px solid #D9D9D9", borderRadius: '10px', marginTop: '15px' }}>
                                        <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#0C0B10" }}>Cost per Lead</h5>
                                            <h5 style={{ margin: '0', padding: '0', fontSize: '12px', color: "#686C70" }}>{tableData?.stats?.costPerLead ?? 0}</h5>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '30px' }}>
                            
                            <div className='main-customized-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th style={{ borderTopLeftRadius: '10px' }}>Partners</th>
                                            <th>Budgeted Disbursement</th>
                                            <th>Actual Disbursement</th>
                                            <th>Variance%</th>
                                            <th style={{ borderTopRightRadius: '10px' }}>Status</th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData?.length > 0 ? tableData?.map((val, id) => {
                                                return (
                                                    <tr key={id}>

                                                        <td></td>
                                                    </tr>
                                                )
                                            })
                                                : ""}

                                        <tr>
                                            <td>
                                                Partner A
                                            </td>
                                            <td>
                                                50
                                            </td>
                                            <td>
                                                50
                                            </td>
                                            <td>
                                                50
                                            </td>

                                            <td>
                                                <div style={{ display: 'inline-block', borderRadius: '4px', padding: '8px', background: "#8A38F51A", color: "#8A38F5" }}>
                                                    Within Budget
                                                </div>
                                            </td>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <div className='Areachart-box' style={{ marginTop: '30px' }}>
                            <div className='topHeader'>
                                <div>
                                    <h5>Budget Breakdown</h5>
                                </div>
                            </div>
                            <div style={{ height: '80px' }}>
                                <ResponsiveContainer width={100} height={100}>
                                    <BarChart
                                        // style={{ width: '100%', maxWidth: '700px', maxHeight: '70vh', aspectRatio: 1.618 }}
                                        responsive
                                        data={[]}
                                        margin={{
                                            top: 5,
                                            right: 0,
                                            left: 0,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid vertical={false} horizontal={false} />
                                        <XAxis dataKey={"name"} tick={false} />
                                        <YAxis width="auto" tick={false} />
                                        <Tooltip />
                                        <Legend />
                                        <Bar dataKey="pv" fill={"#4FA564"} radius={[10, 10, 10, 10]} />


                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* ── Add Budget Plan Popup Modal ── */}
            {showAddBudget && (
                <div style={overlayStyle} onClick={() => setShowAddBudget(false)}>
                    <div style={modalStyle} onClick={e => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#111827' }}>Add Budget Plan</h3>
                            <button style={closeBtnStyle} onClick={() => setShowAddBudget(false)}>×</button>
                        </div>
                        <div style={modalBodyStyle}>
                            <div className="row">
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>Aggregator</label>
                                        <select style={{ ...inputStyle, backgroundColor: '#f3f4f6' }} value={objectData.aggregator} disabled>
                                            <option value={Data?.id}>{Data?.name || Data?.id}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>Start Date</label>
                                        <input style={inputStyle} type="date" value={objectData.startDate} onChange={(e) => handleChange(e, "startDate")} />
                                    </div>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>End Date</label>
                                        <input style={inputStyle} type="date" value={objectData.endDate} onChange={(e) => handleChange(e, "endDate")} />
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '10px' }}>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>Total Budget</label>
                                        <input style={inputStyle} type="text" value={objectData.totalBudget} onChange={(e) => handleChange(e, "totalBudget")} />
                                    </div>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>No. of Leads Expected</label>
                                        <input style={inputStyle} type="number" value={objectData.leadsExpected} onChange={(e) => handleChange(e, "leadsExpected")} />
                                    </div>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>Commited Leads</label>
                                        <input style={inputStyle} type="text" value={objectData.commitedLeads} onChange={(e) => handleChange(e, "commitedLeads")} />
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '10px' }}>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>Commited Disbursement</label>
                                        <input style={inputStyle} type="text" value={objectData.commitedDisbursment} onChange={(e) => handleChange(e, "commitedDisbursment")} />
                                    </div>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>Commited Disbursement Amount</label>
                                        <input style={inputStyle} type="number" value={objectData.commitedDisbursmentAmount} onChange={(e) => handleChange(e, "commitedDisbursmentAmount")} />
                                    </div>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={fieldGroupStyle}>
                                        <label style={labelStyle}>Expected Disbursment Amount</label>
                                        <input style={inputStyle} type="text" value={objectData.expectedDisbursmentAmount} onChange={(e) => handleChange(e, "expectedDisbursmentAmount")} />
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '10px' }}>
                                <div className="col-sm-4 col-xs-12">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', height: '100%', paddingTop: '20px' }}>
                                        <CustomCheckbox2
                                            checked={objectData.notify}
                                            onChange={(e) => handleChange(e, "notify")}
                                        />
                                        <label style={{ ...labelStyle, margin: 0, cursor: 'pointer' }} onClick={() => handleChange({ target: { checked: !objectData.notify } }, "notify")}>Notify on Budget/Lead Exceed</label>
                                    </div>
                                </div>
                                {objectData.notify && (
                                    <div className="col-sm-4 col-xs-12">
                                        <div style={fieldGroupStyle}>
                                            <label style={labelStyle}>Email</label>
                                            <input style={inputStyle} type="email" value={objectData.email} onChange={(e) => handleChange(e, "email")} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={modalFooterStyle}>
                            <button style={cancelBtnStyle} onClick={() => setShowAddBudget(false)}>Cancel</button>
                            <button style={saveBtnStyle} onClick={handleSaveBudget}>Save</button>
                        </div>
                    </div>
                </div>
            )}

            {popup.show && <Popup popupStatus={popup.popupStatus} closePopup={closePopup} />}
        </>
    )
}
